import { Injectable, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment.prod";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class ProductsService {
    public userEmit: EventEmitter<ProductsService>;

    constructor(private http: HttpClient) {
        this.userEmit = new EventEmitter();
    }

    /// ======= get  products    ======= ///
    getProductById(id: number) {
        return this.http
            .get<any>(`${environment.api}/api/customer/products/` + id)
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    
    getProductBySlug(slug: string) {
        return this.http
            .get<any>(`${environment.api}/api/customer/products/${slug}/slug`)
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    getComparedProductById(id: number) {
        return this.http
            .get<any>(
                `${environment.api}/api/customer/products/` + id + `/variant`
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    autoCompleteSearch(data: any) {
        return this.http
            .post<any>(`${environment.api}/api/customer/search`, data)
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    getProductsSearch(data: any , pram? : any) {
        return this.http
            .post<any>(`${environment.api}/api/customer/products/search?${pram}`, data)
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    getBankInstallmentsByPrice(price: number) {
        return this.http
            .get<any>(
                `${environment.api}/api/customer/bank-installments/` + price
            )
            .pipe(
                map((bank) => {
                    return bank;
                })
            );
    }
}
